import { HTTP } from './http-common'
import responseCode from './http-response-codes'

export default {
  login(payload, commit) {
    return HTTP.post(`account/login?sendClaims=false`, payload)
      .then(res => {
        commit('SET_ERROR_MESSAGE', '')
        return res
      })
      .catch(error => {
        if (error.response.status === responseCode.badRequest) {
          commit('SET_ERROR_MESSAGE', 'Het emailadres en/of wachtwoord is onjuist')
        } else {
          commit('SET_ERROR_MESSAGE', 'Er is iets fout gegaan')
        }
      })
  },
  getBearerToken(payload) {
    return HTTP.post('account/refresh?sendClaims=false', payload)
  },
  getCurrentUser() {
    return HTTP.get('/account/me/')
  },
  removeClaimUser(username, scope, identifier) {
    return HTTP.delete(`account/${username}/claims/${scope}/${identifier}`)
  },
  addClaimUser(username, payload) {
    return HTTP.post(
      `account/${username}/claims?scope=${payload.scope}&identifier=${payload.identifier}&level=${payload.level}`
    ).then(res => {
      return res
    })
  },
  disableUser(username) {
    return HTTP.post(`account/${username}/disable`)
  },
  resetpasswordUser(username) {
    return HTTP.post(`account/reset_password`, {email: username})
  },
  enableUser(username) {
    return HTTP.post(`account/${username}/enable`)
  },
  forgotPassword(userInfo) {
    console.log(userInfo)
    return HTTP.post('account/reset_password', userInfo)
  },
  async registerUser(userInfo)  {
    console.log(userInfo)
    const res =await  HTTP.post('account/', userInfo)
    console.log(res)
    return res
  },
  resetPassword(payload) {
    return HTTP.post('account/reset_password_code', payload)
  },
  confirmEmail(userId, code) {
    return HTTP.post(`account/conformation_email?userId=${userId}&code=${encodeURIComponent(code)}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/userService.js